import {logger} from "../utils/Logger";

export const enum SettingsLevel {
    System,
    Domain,
    User
}

/**
 * level (system, domain or user) and email address for user level and domain name for a domain level
 */
export interface SettingsLevelAndSubLevel {
    settingsLevel : SettingsLevel,
    settingsLevelSubSelector : string | undefined,
    categories: string[]
}

/**
 * Returns the current settings level (system, domain, user), sub-level (email for user level, domain for domain level)
 * and the settings categories (example: [sms, sms-transports, clickatell])
 *
 * Note: this function will remove items from path without making a copy!! this is important because it will remove
 * all level path parameters and the path will then only contain the specific settings (sms/.../...)
 */
function getSettingsLevelAndSubLevel(path : string[] | undefined) : SettingsLevelAndSubLevel
{
    if (path === undefined || path.length < 2) {
        throw new Error(`path ${path} is invalid`);
    }

    const levelFromPath = path.shift()?.toLowerCase();

    let settingsLevel : SettingsLevel;
    // will be set to the domain if level is domain and email address of the user if level is user and
    // undefined if level is system
    let settingsLevelSubSelector;

    switch (levelFromPath) {
        case "system": {
            settingsLevel = SettingsLevel.System;
            break;
        }
        case "domains": {
            settingsLevel = SettingsLevel.Domain;
            settingsLevelSubSelector = path.pop();
            break;
        }
        case "users": {
            settingsLevel = SettingsLevel.User;
            settingsLevelSubSelector = path.pop();
            break;
        }
        default: {
            throw new Error(`Invalid level ${levelFromPath}`);
        }
    }

    logger.debug(`Level: ${settingsLevel}, Level sub-selector: ${settingsLevelSubSelector}, Categories: ${path}`)

    return {
        settingsLevel : settingsLevel,
        settingsLevelSubSelector : settingsLevelSubSelector,
        categories : path};
}

export const SettingsUtils = () => {
    return
}

SettingsUtils.getSettingsLevelAndSubLevel=getSettingsLevelAndSubLevel
